import type { RouteObject } from 'react-router';
import MainLayout from '~/ui/layout/MainLayout';
import { SubscriptionPurchaseProvider, SubscriptionStepProvider } from '~/services/internalApi/subscription';
import { SubscriptionPurchaseFlowPage } from '~/pages/subscription/SubscriptionPurchaseFlowPage';
import { SubscriptionConfirmationPage } from '~/pages/subscription/SubscriptionConfirmationPage';

/**
 * Subscription Routes
 * Handles memberships, passes, and subscription management
 * 
 * Layout: MainLayout
 * Auth Guard: requireAuth + requireOnboardingCompleted (TODO)
 * 
 * Note: SubscriptionPurchaseProvider + SubscriptionStepProvider wrap the purchase flow
 * to manage selection state and step navigation (similar to BookingProvider pattern).
 */
export const subscriptionRoutes: RouteObject[] = [
  {
    path: '/subscriptions',
    element: <MainLayout />,
    children: [
      // Purchase flow - single route with step-based navigation
      {
        index: true,
        element: (
          <SubscriptionPurchaseProvider>
            <SubscriptionStepProvider>
              <SubscriptionPurchaseFlowPage />
            </SubscriptionStepProvider>
          </SubscriptionPurchaseProvider>
        ),
      },
      // Confirmation page (after successful purchase)
      // Uses composite ID format: membership-123 or pass-456
      {
        path: 'confirmed/:compositeId',
        element: <SubscriptionConfirmationPage />,
      },
    ],
  },
];
